// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { AppDataProvider } from "./contexts/AppDataContext";

import HeroSection from "./components/HeroSection";
import SecSection from "./components/SecSection";
import ImagineRow from "./components/ImagineRow";
import HowToWorkRow from "./components/howToWorkRow";
import SupportGrid from "./components/SupportGrid";
import JoinExperts from "./components/JoinExperts";
import FAQ from "./components/FAQ";
import ContactUs from "./components/ContactUs";
import FirstStepSection from "./components/FirstStepSection";
import Footer from "./components/Footer";
import ApplyForm from "./components/Form/ApplyForm";
import Header from "./components/Header";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ShareLanding from "./components/ShareLanding";

function RootLayout() {
  return (
    <>
      <Header />
      {/* الأب المسؤول عن المسافات الموحدة */}
      <main className="page">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

function Home() {
  return (
    <>
      <HeroSection />
      <SecSection />
      <ImagineRow />
      <HowToWorkRow />
      <SupportGrid />
      <JoinExperts />
      <FAQ />
      <ContactUs />
      <FirstStepSection />
    </>
  );
}

export default function App() {
  return (
    <AppDataProvider>
      <BrowserRouter basename="/landing">
        <Routes>
          <Route element={<RootLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/apply" element={<ApplyForm />} />
            <Route path="/specialist/:id" element={<ShareLanding />} />
            <Route path="/package/:id" element={<ShareLanding />} />
            <Route path="/scale/:id" element={<ShareLanding />} />
            <Route path="/article/:id" element={<ShareLanding />} />
            <Route path="/meeting/:id" element={<ShareLanding />} />
          </Route>
          {/* Standalone Privacy Policy page - no header/footer */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
    </AppDataProvider>
  );
}
